import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext.jsx';
import { Button } from './ui/button';

/**
 * Selector de tema (claro/oscuro/sistema).
 * Variante "buttons": tres botones pequeños para usar en menús.
 * Variante "select": un único botón que cicla entre los tres estados.
 */
const ThemeToggle = ({ variant = 'buttons' }) => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  if (variant === 'select') {
    const next = theme === 'light' ? 'dark' : theme === 'dark' ? 'system' : 'light';
    const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
    const label = theme === 'light' ? 'Claro' : theme === 'dark' ? 'Oscuro' : 'Sistema';
    return (
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setTheme(next)}
        title={`Tema: ${label}`}
        aria-label={`Cambiar tema (actual: ${label})`}
      >
        <Icon className="h-5 w-5" />
      </Button>
    );
  }

  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-border bg-background p-1">
      {[
        { value: 'light', Icon: Sun, label: 'Claro' },
        { value: 'system', Icon: Monitor, label: 'Sistema' },
        { value: 'dark', Icon: Moon, label: 'Oscuro' },
      ].map(({ value, Icon, label }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setTheme(value)}
            title={label}
            aria-label={label}
            className={`inline-flex h-7 w-7 items-center justify-center rounded transition-colors ${
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground hover:bg-accent'
            }`}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
